import { render, staticRenderFns } from "./FactoryAccessDashboardLayout.vue?vue&type=template&id=0322fc3e&scoped=true"
import script from "./FactoryAccessDashboardLayout.vue?vue&type=script&lang=js"
export * from "./FactoryAccessDashboardLayout.vue?vue&type=script&lang=js"
import style0 from "./FactoryAccessDashboardLayout.vue?vue&type=style&index=0&id=0322fc3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0322fc3e",
  null
  
)

export default component.exports